import { render, staticRenderFns } from "./VillaInfoContainer.vue?vue&type=template&id=0bb981bf&scoped=true&"
import script from "./VillaInfoContainer.vue?vue&type=script&lang=js&"
export * from "./VillaInfoContainer.vue?vue&type=script&lang=js&"
import style0 from "./VillaInfoContainer.vue?vue&type=style&index=0&id=0bb981bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb981bf",
  null
  
)

export default component.exports